import React from 'react'

function Upcoming() {
  return (
    <div>
        {/* <!-- CONTENT START --> */}
        <div class="page-content">
           
            
			{/* <!-- SECTION CONTENT START --> */}
            <div class="section-full p-tb80 inner-page-padding">
            	<div class="container">
                    <div class="project-detail-outer">
                    	<img src="images/webimgs/624.jpg" alt="img" width={800}/>
                      
                    </div>
                </div>
            </div>
            {/* <!-- SECTION CONTENT END  --> */}
            
          

        </div>
        {/* <!-- CONTENT END --> */}
    </div>
  )
}

export default Upcoming